import {
  collection,
  query,
  onSnapshot,
  setDoc,
  doc,
  getDocs,
  limit,
  orderBy,
  where,
} from "firebase/firestore";
import { db, functions } from "@/firebase";
import { httpsCallable } from "firebase/functions";

const agent = {
  state: {
    chat: [],
    chat_uid: null,
    unsubscribe: null,
    showAgent: false,
    showChat: false,
    loading: false,
    recent_chat: [],
    recent_chat_uid: null,
    loading_recent_chat: false,
  },
  mutations: {
    setUnsubscribe(state, val) {
      state.unsubscribe = val;
    },
    setChatUid(state, val) {
      state.chat_uid = val;
    },
    addMessage(state, val) {
      state.chat.push(val);
    },
    toggleAgentShow(state) {
      state.showAgent = !state.showAgent;
    },
    setShowChat(state, val) {
      state.showChat = val;
    },
    clearAgent(state) {
      state.chat = [];
      state.chat_uid = null;
    },
    setRecentChat(state, val) {
      state.recent_chat = val;
    },
    setRecentChatUid(state, val) {
      state.recent_chat_uid = val;
    },
    unsubscribe(state) {
      state.unsubscribe;
    },
    setLoadingRecentChat(state, val) {
      state.loading_recent_chat = val;
    },
    setAgentLoading(state, val) {
      state.loading = val;
    },
  },
  actions: {
    async AddChatMessage({ commit, state, rootState, dispatch }, val) {
      console.log("adding message: " + val);
      commit("setAgentLoading", true);
      let now = Math.floor(Date.now());
      if (state.chat_uid === null) {
        await setDoc(
          doc(
            db,
            "workspaces",
            rootState.users.userProfile.workspace,
            "chats",
            String(now),
          ),
          {
            created_at: Math.floor(now / 1000),
            user: rootState.users.userProfile.uid,
            uid: String(now),
          },
        );

        commit("setChatUid", String(now));
        commit("setShowChat", true);
        dispatch("initializeChat");
      }

      let context = {
        post_draft: rootState.post.variations[rootState.post.tab].text || null,
        post_media:
          rootState.post.media.map((m) => {
            return {
              src: m.src || null,
              type: m.type || null,
              url: m.url || null,
              html: m.html || null,
              extension: m.extension || null,
            };
          }) || null,
        structure: rootState.post.structure || null,
        category: rootState.post.category || null,
        carousel: rootState.post.carousel || null,
        sources: rootState.knowledge.sources || [],
      };

      await setDoc(
        doc(
          db,
          "workspaces",
          rootState.users.userProfile.workspace,
          "chats",
          state.chat_uid,
          "messages",
          String(now),
        ),
        {
          created_at: Math.floor(now / 1000),
          user: rootState.users.userProfile.uid,
          content: val,
          role: "user",
          type: "message",
          context: context,
        },
      );

      try {
        const anything = httpsCallable(functions, "chatAgent");
        const result = await anything({
          message: val,
          workspace: rootState.users.userProfile.workspace,
          chat_uid: state.chat_uid,
          context: context,
        });
        console.log(result.data);
      } catch (error) {
        console.log(error);
        if (error.message.includes("Not enough tokens")) {
          commit("setNotification", {
            show: true,
            text: "Not enough tokens",
            type: "error",
          });
        } else {
          commit("setNotification", {
            show: true,
            text: "Agent service temporarily unavailable",
            type: "error",
          });
        }
      }

      commit("setAgentLoading", false);
      return;
    },
    async fetchChat({ commit, rootState }) {
      console.log("brands: ", rootState.workspace.brands);
      if (rootState.workspace.brands.length === 1) {
        commit("setPostBrand", rootState.workspace.brands[0]);
        commit("setPostVoice", rootState.workspace.brands[0].voices[0]);
      }

      console.log("fetching chat");
      const q = query(
        collection(
          db,
          "workspaces",
          rootState.users.userProfile.workspace,
          "chats",
        ),
        where("user", "==", rootState.users.userProfile.uid),
        limit(1),
        orderBy("created_at", "desc"),
      );
      const querySnapshot = await getDocs(q);
      let recent_chat = [];
      querySnapshot.docs.map(async (doc) => {
        const messages = await getDocs(
          collection(
            db,
            "workspaces",
            rootState.users.userProfile.workspace,
            "chats",
            doc.id,
            "messages",
          ),
        );
        messages.docs.map((m) => {
          recent_chat.push(m.data());
        });
      });
      commit("setRecentChat", recent_chat);
      if (querySnapshot.docs.length > 0) {
        commit("setRecentChatUid", querySnapshot.docs[0].id);
      }
    },
    async initializeChat({ commit, state, rootState }) {
      console.log("initializing chat");

      let lastPostId;
      let lastPostDocId;
      if (state.loading_recent_chat) {
        const lastPostQuery = query(
          collection(
            db,
            "workspaces",
            rootState.users.userProfile.workspace,
            "chats",
            state.chat_uid,
            "messages",
          ),
          orderBy("created_at", "desc"),
        );
        const lastPostSnapshot = await getDocs(lastPostQuery);
        // Find the last message with response_type === 'post'
        let lastPostDoc = lastPostSnapshot.docs.find(
          (doc) => doc.data().response_type === "post",
        );
        if (lastPostDoc) {
          lastPostDocId = lastPostDoc.id;
        }

        lastPostId = lastPostSnapshot.docs[0].id;
      }
      console.log("lastPostId: ", lastPostId);
      console.log("state.loading_recent_chat: ", state.loading_recent_chat);
      const q = query(
        collection(
          db,
          "workspaces",
          rootState.users.userProfile.workspace,
          "chats",
          state.chat_uid,
          "messages",
        ),
      );
      const unsubscribe = onSnapshot(q, (snapshot) => {
        snapshot.docChanges().forEach((change) => {
          if (change.type === "added") {
            console.log("Added message: ", change.doc.id);
            commit("addMessage", change.doc.data());

            if (change.doc.data().post_content && !state.loading_recent_chat) {
              commit("setPostVariationText", {
                index: rootState.post.tab,
                text: change.doc.data().post_content,
              });
              commit("setPostSelectedSlideIndex", 0);

              console.log(
                "change.doc.data().carousel: ",
                change.doc.data().carousel,
              );
              if (
                change.doc.data().carousel &&
                change.doc.data().carousel.length > 0
              ) {
                commit("setPostCarousel", change.doc.data().carousel);
              }
            }

            if (
              change.doc.data().carousel &&
              change.doc.data().carousel.length > 0 &&
              change.doc.data().carousel[0]?.slide_html &&
              !state.loading_recent_chat
            ) {
              commit("setPostCarousel", change.doc.data().carousel);
            }

            if (change.doc.data().image_html && !state.loading_recent_chat) {
              commit("setPostMedia", [
                {
                  src: null,
                  type: "image",
                  extension: "html",
                  html: change.doc.data().image_html,
                },
              ]);
            }

            if (change.doc.data().response_type === "chat" && !state.showChat) {
              commit("setShowChat", true);
            }

            if (change.doc.id === lastPostDocId && state.loading_recent_chat) {
              commit("setPostVariationText", {
                index: rootState.post.tab,
                text: change.doc.data().post_content,
              });
            }

            if (change.doc.id === lastPostId && state.loading_recent_chat) {
              commit("setLoadingRecentChat", false);
              console.log("loading_recent_chat: false");
            }
          }
          if (change.type === "modified") {
            console.log("Modified city: ", change.doc.data());
          }
          if (change.type === "removed") {
            console.log("Removed city: ", change.doc.data());
          }
        });
      });
      commit("setUnsubscribe", unsubscribe);
    },
  },
  getters: {},
};

export default agent;
